import { useEffect, useState } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { getDate } from "@poseidon/firebase/timestamp";

export const useIdvNotesLog = (sailorId) => {
  const [idvNotesLog, setIdvNotesLog] = useState([]);
  const [value, loading, error] = useCollection(
    query(
      collection(db, "sailorRiskProfiles", sailorId, "idvNotes"),
      orderBy("createdAt", "asc")
    )
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        createdAt: getDate(doc.get("createdAt")),
      }));
      setIdvNotesLog(docs);
    }
  }, [value]);

  return { idvNotesLog, loading, error };
};
